module.exports = {"150929100":"四子王旗乌兰花镇","150929101":"四子王旗吉生太镇","150929102":"四子王旗库伦图镇","150929103":"四子王旗供济堂镇","150929104":"四子王旗白音朝克图镇","150929200":"四子王旗红格尔苏木","150929201":"四子王旗江岸苏木","150929202":"四子王旗查干补力格苏木","150929203":"四子王旗脑木更苏木","150929204":"四子王旗东八号乡","150929205":"四子王旗忽鸡图乡","150929206":"四子王旗大黑河乡","150929207":"四子王旗巴音敖包苏木","150929400":"四子王旗乌兰牧场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/150929.json
// module id = 475
// module chunks = 0